

const Footer = () => {
  return (
    <footer className='text-center my-3'>This app was created by Jahmella Williams copyright 2022</footer>
  )
}

export default Footer